import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Component } from "@angular/core";

@Component({
    template: `
        <div mat-dialog-title>Create Topic</div>
        <div mat-dialog-content [formGroup]="form">
            <mat-form-field>
                <input matInput placeholder="Topic Name" formControlName="name">
                <mat-error *ngIf="form.get('name').hasError('required')">Topic Name is required.</mat-error>
            </mat-form-field>
        </div>
        <div mat-dialog-actions>
            <button mat-raised-button color="primary" [disabled]="form.invalid" [mat-dialog-close]="form.get('name').value">Save</button>
            <button mat-button mat-dialog-close>Cancel</button>
        </div>
    `
})
export class NameTopicDialogComponent {
    form: FormGroup;

    constructor(fb: FormBuilder) {
        this.form = fb.group({ name: fb.control('', Validators.required)});
    }
}    
